// i18n.js - Configuração de idiomas (Português e Inglês)
//
// O idioma é uma preferência POR DISPOSITIVO, guardada em localStorage.
// Podia ser guardada no perfil do utilizador, mas por dispositivo é o
// comportamento mais comum e mais útil na prática: o telemóvel pode estar
// em português e o portátil do escritório em inglês sem se atropelarem.
// Ficou também frontend puro, o que evita mais um reinício do backend.
//
// Na primeira visita segue o idioma do browser; se não for português,
// abre em inglês.
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import pt from './locales/pt.json';
import en from './locales/en.json';

export const IDIOMAS = [
  { code: 'pt', label: 'PT', nome: 'Português' },
  { code: 'en', label: 'EN', nome: 'English' },
];

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      pt: { translation: pt },
      en: { translation: en },
    },
    // 'en' e não 'pt': um browser em francês, espanhol ou alemão abre em
    // inglês, que é a convenção. O português fica para quem tem mesmo o
    // browser em português.
    fallbackLng: 'en',
    supportedLngs: ['pt', 'en'],
    // 'pt-PT' e 'pt-BR' caem ambos em 'pt'
    load: 'languageOnly',
    detection: {
      order: ['localStorage', 'navigator'],
      lookupLocalStorage: 'idioma',
      caches: ['localStorage'],
    },
    interpolation: {
      // O React já escapa o que é interpolado
      escapeValue: false,
    },
  });

/** Mudar de idioma e guardar a escolha */
export function mudarIdioma(code) {
  i18n.changeLanguage(code);
  document.documentElement.lang = code;
}

// Manter o atributo lang do <html> em dia - conta para leitores de ecrã
// e para o browser saber que idioma está a mostrar
i18n.on('languageChanged', (lng) => {
  document.documentElement.lang = lng;
});

export default i18n;
